import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
const ChatHeader = ({ activeProject, projects, projectsLoading, projectsError, handleProjectSelection, isSidebarOpen, onToggleSidebar, subscriptionPlan = 'Free' }) => {

    const { t, i18n } = useTranslation();
    const user = useSelector((state) => state.serviceProvider.serviceProvider);
    const [isOpen, setIsOpen] = useState(false);
    const [isLanguageOpen, setIsLanguageOpen] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState(i18n.language || 'en');


    useEffect(() => {
        const currentLang = i18n.language?.split('-')[0] || 'en';
        setSelectedLanguage(currentLang);
    }, [i18n.language]);

    useEffect(() => {
        const handleClickOutside = () => {
            setIsOpen(false);
            setIsLanguageOpen(false); // Agregar para cerrar también el dropdown de idiomas
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    const handleLanguageChange = async (lang) => {
        setSelectedLanguage(lang);
        setIsLanguageOpen(false);
        await i18n.changeLanguage(lang);
        localStorage.setItem('userLanguage', lang);
    };

    const languages = [
        { code: 'en', name: 'English', abbr: 'EN' },
        { code: 'es', name: 'Español', abbr: 'ES' },
        { code: 'fr', name: 'Français', abbr: 'FR' },
        { code: 'de', name: 'Deutsch', abbr: 'DE' },
        // { code: 'zh', name: '中文', abbr: 'ZH' },
        // { code: 'ja', name: '日本語', abbr: 'JA' },
        { code: 'pt', name: 'Português', abbr: 'PT' },
        { code: 'it', name: 'Italiano', abbr: 'IT' }
    ];

    return (
        <div className="chat-header">
            <div className="chat-header-content">
                <div className="chat-header-left">
                    <button
                        className="hamburger-menu"
                        onClick={() => onToggleSidebar(!isSidebarOpen)}
                        aria-label="Toggle sidebar"
                    >
                        <span className="hamburger-icon">☰</span>
                    </button>
                    <div className="header-title-group">
                        <h1 className="chat-header-title">CBrainAI<span className="beta-badge">BETA</span></h1>
                        <span className="chat-header-subtitle">Construction Experts In Your Pocket</span>
                    </div>
                </div>


                <div className="chat-header-right">
                    <div className="d-none d-md-block language-selector-wrapper">
                        <button
                            className="language-selector"
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsLanguageOpen(!isLanguageOpen);
                            }}
                            aria-label="Select language"
                        >
                            <svg
                                className="language-icon"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <circle cx="12" cy="12" r="10" />
                                <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                            </svg>
                            <span className="language-code">{selectedLanguage.toUpperCase()}</span>
                        </button>

                        {isLanguageOpen && (
                            <div className="language-dropdown language-dropdown-scrollable" onClick={(e) => e.stopPropagation()}>
                                {languages.map((lang) => (
                                    <button
                                        key={lang.code}
                                        className={`language-dropdown-item ${selectedLanguage === lang.code ? 'active' : ''}`}
                                        onClick={() => handleLanguageChange(lang.code)}
                                    >
                                        <span className="language-name">{lang.name}</span>
                                        <span className="language-abbr">{lang.abbr}</span>
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    <span className={`d-none d-md-block subscription-badge ${user?.subscription?.plan ? user?.subscription?.plan.toLowerCase() : 'guest'}`}>
                        {user?.subscription?.plan ? user?.subscription?.plan : 'Guest'}
                    </span>
                    <div className="context-selector-wrapper">
                        <button className="context-selector" onClick={(e) => { e.stopPropagation(); setIsOpen(!isOpen); }}>

                            <span className="context-name">{activeProject ? activeProject.name : 'Projects'}</span>
                            <span className="context-arrow">{isOpen ? '▴' : '▾'}</span>
                        </button>

                        {/* {isOpen && (
                            <div className="project-dropdown" onClick={(e) => e.stopPropagation()}>
                                <button
                                    className={`project-dropdown-item ${!activeProject ? 'active' : ''}`}
                                    onClick={() => { handleProjectSelection(null); setIsOpen(false); }}
                                >

                                    <span>General</span>
                                </button>
                                {projects && projects.length > 0 ? (
                                    projects.map(proj => (
                                        <button
                                            key={proj.id}
                                            className={`project-dropdown-item ${activeProject?.id === proj.id ? 'active' : ''}`}
                                            onClick={() => { handleProjectSelection(proj); setIsOpen(false); }}
                                        >

                                            <span>{proj.name}</span>
                                        </button>
                                    ))
                                ) : (
                                    <div className="project-dropdown-item-none">No projects yet</div>
                                )}
                            </div>
                        )} */}
                        
                        {isOpen && (
                            <div className="project-dropdown" onClick={(e) => e.stopPropagation()} onMouseLeave={() => setIsOpen(false)}>
                                <div className="project-dropdown-beta-notice">
                                    {/* <div className="beta-notice-header">
                                        <svg className="info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <circle cx="12" cy="12" r="10" />
                                            <line x1="12" y1="16" x2="12" y2="12" />
                                            <line x1="12" y1="8" x2="12.01" y2="8" />
                                        </svg>
                                        <span className="beta-notice-title">
                                            {t('chatHeader.betaFeature', 'This feature will be available after BETA.')}
                                        </span>
                                    </div> */}
                                    <p className="beta-notice-title m-0">
                                        {t('chat_header.beta_feature_description', 'This feature will be available after BETA.')}
                                    </p>
                                </div>
                                
                                <div className="project-info-section">
                                    <h4 className="project-info-title">
                                        {t('chat_header.title_beta', 'Why create a project?')}
                                    </h4>
                                    <p className="project-info-text">
                                        {t('chat_header.project_benefits', 'Context matters. Creating a project establishes a baseline that enables intelligent planning decisions. A clear definition of your project —what is to be built and the step-by-step process— enables me to provide better project-specific answers and guidance.')}
                                    </p>
                                </div>                               
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {projectsLoading && <div className="status-message">Actualizando proyectos...</div>}
            {projectsError && <div className="status-message error">Error: {projectsError}</div>}
        </div>
    );
};

export default ChatHeader;